export default __webpack_public_path__ + "static/Case-Study-Global-cloud-storage-6ebb0abefb3eeb4c0571b70f0fae3e42.pdf";